import { safeRedirectPath } from '@sbg/shared/utils';

/**
 * Where an anonymous visitor is sent: `/admin?next=<the page they wanted>` — signing in lives at `/admin` (D-391). The wanted
 * location is run through `safeRedirectPath` (same-origin relative paths only, never `/api/*`), so a crafted URL can never
 * turn the login redirect into an open redirect.
 */
export function loginRedirectTarget(pathname: string, search = '', hash = ''): string {
  const next = safeRedirectPath(`${pathname}${search}${hash}`, '/');
  return `/admin?next=${encodeURIComponent(next)}`;
}
